import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SplashScreen } from '@capacitor/splash-screen';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ErrorButtonActionEnum } from '@qvs/core';
import { windowToken } from '~/shared/helpers/window-helper';
import { AssetByColorModePipe } from '../../pipes/asset-by-color-mode.pipe';
import { SvgIconComponent } from '../../form-elements/components/svg-icon/svg-icon.component';
import { ScrollDirective } from '../../directives/scroll.directive';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'qvs-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: true,
  imports: [IonicModule, ScrollDirective, SvgIconComponent, TranslatePipe, AssetByColorModePipe]
})
export class ErrorComponent implements OnInit {
  src: { light: string; dark: string };
  description: string;
  buttonActionEnum: ErrorButtonActionEnum;

  constructor(
    @Inject(windowToken) private readonly window: Window,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data) => {
      this.src = data.src;
      this.description = data.description;
      this.buttonActionEnum = data.buttonAction;
    });
    SplashScreen.hide();
  }

  contactUs() {
    if (this.buttonActionEnum === ErrorButtonActionEnum.CALL_SUPPORT) {
      this.window.location.href = this.translateService.instant('error.TEL');
    } else {
      this.router.navigateByUrl('/pages/chat');
    }
  }
}
